import React, { useState, useEffect, useContext } from "react";
import { identifyTenant } from '../analytics/identify';
import { Auth, API, graphqlOperation } from "aws-amplify";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import LeftNavbar from "./LeftNavbar";
import { Context } from "../Utility/ContextManager";
import { SpinnerLoading } from "./Loadings";
import { checkvalidateTenant, fetchSignedUrl, getListChangePasswords, getTenantInfo } from "../Utility/ApiService";
import { logOut } from "../Utility";
import envFile from "../envFile";
import { onCreateChangePassword, onUpdateChangePassword } from "../graphql/subscriptions";

const Container = ({ children, isHideSideBar }) => {
  const { setUser } = useContext(Context);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  let subscription1;
  let subscription2;

  useEffect(() => {
    fetchTenantInfo();

    return () => {
      if (subscription1) subscription1.unsubscribe();
      if (subscription2) subscription2.unsubscribe();
    };
  }, []);

  const fetchTenantInfo = async () => {
    const user = await Auth.currentAuthenticatedUser();
    const tenantEmail = user.attributes?.email;
    await getTenantInfo(tenantEmail)
      .then(async (parsedTenantInfo) => {
        if (parsedTenantInfo && parsedTenantInfo.length > 0) {
          await fetchProfilePicture(parsedTenantInfo[0]);
          checkTenantStatus(parsedTenantInfo[0]);
          setLoading(false);
        } else {
          toast.error("No record found for this tenant");
          await logOut();
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
        if (err?.message === "No current user") {
          logOut();
        } else {
          toast.error(err?.message || "Something went wrong please try again later");
        }
      });
  };

  const fetchProfilePicture = async (user) => {
    let pictrue;
    if (user.profile_picture) {
      pictrue = await fetchSignedUrl(user?.profile_picture, "profile_pictures");
    }
    setUser({
      ...user,
      profile_picture: pictrue ? pictrue : "",
    });
    identifyTenant(user);
  };

  const checkTenantStatus = async (tenant) => {
    try {
      const response = await checkvalidateTenant({ email: tenant.email });
      if (response.status !== 200) {
        toast.error(`We are unable to log you in at this time, please contact your landlord/property manager.`);
        await logOut();
      }

      if (tenant?.email_verification !== 1) {
        const createdDate = moment(tenant?.created_at);
        const today = moment();
        const noOfday = today.diff(createdDate, "days");
        if (noOfday > envFile.EXPIRED_DAY) {
          navigate("/EmailNotVerify");
        }
      }

      subscription1 = API.graphql(graphqlOperation(onCreateChangePassword)).subscribe({
        next: ({ value }) => value.data.onCreateChangePassword?.tenant_id === tenant.id && logOut(),
        error: (error) => console.warn(error),
      });
      subscription2 = API.graphql(graphqlOperation(onUpdateChangePassword)).subscribe({
        next: ({ value }) => value.data.onUpdateChangePassword?.tenant_id === tenant.id && logOut(),
        error: (error) => console.warn(error),
      });

      const allListChangePasswords = await getListChangePasswords();
      const dd = allListChangePasswords.find((item) => item.tenant_id === tenant.id);
      if (dd) {
        if (moment() <= moment(dd.last_modified)) {
          toast.error(`Password Changed`);
          await logOut();
        }
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong please try again later");
    }
  };

  return (
    <>
      {/* div id="layout-wrapper" */}
      {isHideSideBar ? (
        children
      ) : (
        <>
          <LeftNavbar />

          <div className="main-content">
            <div className="page-content">
              <div className="container-fluid">
                {loading ? (
                  <div className="loadingSpinner">
                    <SpinnerLoading />
                  </div>
                ) : (
                  children
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const PrivateContainer = ({ children, isHideSideBar = false }) => {
  const [isLoggedIn, setisLoggedIn] = useState(false);
  const [isLoadinng, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      await Auth.currentAuthenticatedUser();
      setLoading(false);
      setisLoggedIn(true);
    } catch {
      navigate("/");
      setLoading(false);
      setisLoggedIn(false);
    }
  };

  return isLoadinng ? (
    <div className="loadingSpinner">
      <SpinnerLoading />
    </div>
  ) : isLoggedIn ? (
    <Container isHideSideBar={isHideSideBar}>{children}</Container>
  ) : null;
};

export default PrivateContainer;
